<div id="membership-button" matRipple routerLink="/memberships">

  <ng-container [ngSwitch]="buttonStatus">
    <p *ngSwitchCase="0">
      {{ 'toolbars.membershipPending' | translate }}
    </p>
    <p *ngSwitchCase="1">
      {{ 'toolbars.membershipActive' | translate }}
    </p>
    <p *ngSwitchCase="-1">
      {{ 'toolbars.membershipFree' | translate }}
    </p>
    <p *ngSwitchCase="-2">
      {{ 'toolbars.membershipUpgrade' | translate }}
    </p>
    <p *ngSwitchDefault>
      {{ 'toolbars.beAMemberButtonText' | translate }}
    </p>
  </ng-container>

</div>
